import { RouteName } from "../RouteNames";

/** Refactor routing ok  */
export const reportsRoutes = [
  {
    name: RouteName.ReportRoot,
    path: "reports",
    children: [
      {
        name: RouteName.Report,
        path: "",
        component: () =>
          import("@follaw-fr/views/side_menu_views/ReportsView.vue"),
      },
      {
        name: RouteName.ReportZoom,
        path: ":docRef",
        component: () =>
          import("@follaw-fr/views/side_menu_views/ReportZoomView.vue"),
      },
    ],
  },
  {
    name: RouteName.CR,
    path: "/comptes-rendus/:docRef",
    component: () =>
      import("@follaw-fr/views/side_menu_views/ReportCrZoomView.vue"),
  },
];
